import { render, staticRenderFns } from "./TransactionCustomsCountry.vue?vue&type=template&id=12fcd73b"
import script from "./TransactionCustomsCountry.vue?vue&type=script&lang=js"
export * from "./TransactionCustomsCountry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports